import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'scenic-home-goods',
  name: '门票列表',
  icon: '购',
  group: '景区主页',
  description: '景区在售票种的团购列表，含价格、销量与抢购入口。',
  defaultProps: {
    title: '门票列表',
    showSales: true,
    limit: 3,
    buyText: '抢购'
  }
}
